import { memo, useCallback } from "react"

import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import type { TCreateAction } from "../constants"

interface ICreateActionButtonProps {
  currentAction: TCreateAction
  onActionChange: (action: TCreateAction) => void
  isSubmitting: boolean
}

/**
 * Create action button with checkbox option
 * Checkbox controls whether to create and add another transaction
 */
export const CreateActionButton = memo(function CreateActionButton({
  currentAction,
  onActionChange,
  isSubmitting,
}: ICreateActionButtonProps) {
  const isCreateAnother = currentAction === "create-another"

  const handleCheckboxChange = useCallback(
    (checked: boolean) => {
      onActionChange(checked ? "create-another" : "create")
    },
    [onActionChange],
  )

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <Checkbox
          id="create-another"
          checked={isCreateAnother}
          onCheckedChange={handleCheckboxChange}
          disabled={isSubmitting}
        />
        <Label
          htmlFor="create-another"
          className="text-sm text-muted-foreground cursor-pointer"
        >
          Criar e adicionar outra
        </Label>
      </div>
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Salvando..." : "Criar"}
      </Button>
    </div>
  )
})

CreateActionButton.displayName = "CreateActionButton"
